// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";
import { supportedSystemPositions } from "@/Common/helpers/Positions";
import actionsList from "@Constants/actionsList";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";
import DepartmentalWashoutLayer from "@/Washouts/views/Layers/Departmental/DepartmentalWashoutLayer";

const positions = supportedSystemPositions();
const POSITION = positions.BODY_SHOP.BODY_SHOP_FOREMAN;

export default function BodyShopManagerWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const actions = {
		OVERRIDE_COMPENSATION: actionsList.OVERRIDE_BODY_SHOP_FOREMAN_COMPENSATION,
	};

	return (
		<PageLayer title={`${POSITION} Washouts`} icon={Icon}>
			<DepartmentalWashoutLayer position={POSITION} actions={actions} positionType={"Departmental"} />
		</PageLayer>
	);
}
